import React, { useState } from 'react';
import { Mail, MessageCircle, Gift, Send, ArrowLeft } from 'lucide-react';

const ContactPage = ({ setCurrentPage }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    alert('Takk for din henvendelse! Vi kommer tilbake til deg snart.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-primary-50">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="text-6xl mb-6">📧</div>
            <h1 className="text-4xl font-bold text-secondary-800 mb-4">Kontakt oss</h1>
            <p className="text-xl text-secondary-600 max-w-2xl mx-auto">
              Har du spørsmål om gaver, forslag til forbedringer, eller trenger du hjelp? 
              Vi er her for å hjelpe deg!
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-2xl font-semibold text-secondary-800 mb-6 flex items-center">
                <MessageCircle className="w-6 h-6 mr-2 text-purple-500" />
                Send oss en melding
              </h2>
              
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-secondary-700 mb-2">
                    Navn
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-3 py-2 border border-secondary-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    placeholder="Ditt navn"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-secondary-700 mb-2">
                    E-post
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-3 py-2 border border-secondary-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    placeholder="din@epost.no"
                  />
                </div>
                
                <div>
                  <label htmlFor="subject" className="block text-sm font-medium text-secondary-700 mb-2">
                    Emne
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    className="w-full px-3 py-2 border border-secondary-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  >
                    <option value="">Velg emne</option>
                    <option value="gaveforslag">Gaveforslag</option>
                    <option value="teknisk-hjelp">Teknisk hjelp</option>
                    <option value="forbedringer">Forslag til forbedringer</option>
                    <option value="samarbeid">Samarbeid</option>
                    <option value="annet">Annet</option>
                  </select>
                </div>
                
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-secondary-700 mb-2">
                    Melding
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    className="w-full px-3 py-2 border border-secondary-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    placeholder="Skriv din melding her..."
                  />
                </div>
                
                <button
                  type="submit"
                  className="w-full px-6 py-3 bg-gradient-to-r from-purple-500 to-primary-500 text-white rounded-lg hover:from-purple-600 hover:to-primary-600 transition-all transform hover:scale-105 shadow-lg font-semibold"
                >
                  <Send className="w-5 h-5 inline mr-2" />
                  Send melding
                </button>
              </form>
            </div>

            {/* Contact Info */}
            <div className="space-y-8">
              <div className="bg-white rounded-lg shadow-lg p-8">
                <h3 className="text-xl font-semibold text-secondary-800 mb-4 flex items-center">
                  <Mail className="w-6 h-6 mr-2 text-purple-500" />
                  Få i kontakt
                </h3>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium text-secondary-800">E-post</h4>
                    <p className="text-secondary-600">hei@gavefinner.no</p>
                  </div>
                  <div>
                    <h4 className="font-medium text-secondary-800">Responstid</h4>
                    <p className="text-secondary-600">Vi svarer vanligvis innen 24 timer</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-lg p-8">
                <h3 className="text-xl font-semibold text-secondary-800 mb-4 flex items-center">
                  <Gift className="w-6 h-6 mr-2 text-primary-500" />
                  Ofte stilte spørsmål
                </h3>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium text-secondary-800">Hvordan fungerer gavefinneren?</h4>
                    <p className="text-secondary-600 text-sm">
                      Du beskriver mottakeren og setter et budsjett, så får du personlige gaveforslag.
                    </p>
                  </div>
                  <div>
                    <h4 className="font-medium text-secondary-800">Er tjenesten gratis?</h4>
                    <p className="text-secondary-600 text-sm">
                      Ja, gavefinneren er helt gratis å bruke for alle.
                    </p>
                  </div>
                  <div>
                    <h4 className="font-medium text-secondary-800">Kan jeg foreslå nye kategorier?</h4>
                    <p className="text-secondary-600 text-sm">
                      Absolutt! Send oss en melding med dine forslag.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-purple-500 to-primary-500 rounded-lg shadow-lg p-8 text-white">
                <h3 className="text-xl font-semibold mb-4">
                  Trenger du hjelp med å finne en gave?
                </h3>
                <p className="mb-4">
                  Prøv vår gavefinner for personlige anbefalinger basert på mottakerens interesser!
                </p>
                <button
                  onClick={() => setCurrentPage('gift-finder')}
                  className="px-6 py-3 bg-white text-purple-600 rounded-lg hover:bg-secondary-100 transition-colors font-semibold"
                >
                  <Gift className="w-5 h-5 inline mr-2" />
                  Start gavefinneren
                </button>
              </div>
            </div>
          </div>

          {/* Back button */}
          <div className="text-center mt-12">
            <button
              onClick={() => setCurrentPage('home')}
              className="px-6 py-3 border border-purple-300 text-purple-600 rounded-lg hover:bg-purple-50 transition-colors font-semibold"
            >
              <ArrowLeft className="w-5 h-5 inline mr-2" />
              Tilbake til hjem
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;